// Replaces js/src/errors.js. Toggles `hidden` instead of using $.show()/$.hide(),
// which means it works even if the host page strips inline styles.

const SELECTORS = {
  validation: '.locations-zip--validation',
  noResults:  '.locations-search--validation',
  system:     '.locations-zip--sys-error',
};

function setHidden(selector, hidden) {
  const el = document.querySelector(selector);
  if (!el) return;
  if (hidden) el.setAttribute('hidden', '');
  else el.removeAttribute('hidden');
}

export function show(kind) {
  if (SELECTORS[kind]) setHidden(SELECTORS[kind], false);
}

export function hide(kind) {
  if (SELECTORS[kind]) setHidden(SELECTORS[kind], true);
}

export function hideAll() {
  for (const sel of Object.values(SELECTORS)) setHidden(sel, true);
}
